<div class="container my-5 text-center">
    <h1>Clearing cache</h1>
    @if (cacheSuccess) {
        <h2 style="color: green;">Cache cleared successfully</h2>
    }
    @if (paymentCacheSuccess) {
        <h2 style="color: green;">Payment cache cleared successfully</h2>
    }

    <h2 style="color: green;">Session and local storage cleared successfully</h2>


    <h3>Redirecting back in 3 seconds...</h3>
</div>

